import Modal from "react-bootstrap/Modal";
import React from "react";
import "../../styles/org-buttons.css";
import { buttonText } from "../../utils/buttonText";
import { notificationText } from "../../utils/notificationText";

function DoubleComfirmModal(props) {
  const { datasetName } = props;
  const handleDoubleConfirm = () => {
    props.onDelete(datasetName);
  };

  return (
    <Modal
      {...props}
      size="lg"
      aria-labelledby="contained-modal-title-vcenter"
      centered
    >
      <Modal.Header closeButton closeLabel={buttonText("Close")}>
        <Modal.Title id="contained-modal-title-vcenter">
          {notificationText("Clear Data")}
        </Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <p>
          {notificationText(
            "Data cannot be recovered after deletion, please proceed with caution."
          )}
        </p>
      </Modal.Body>
      <Modal.Footer className="org-modal-footer">
        <button type="button" className="org-btn org-btn-secondary" onClick={props.onHide}>
          {buttonText("Cancel")}
        </button>
        <button
          type="button"
          className="org-btn org-btn-danger"
          onClick={() => {
            props.onHide();
            handleDoubleConfirm();
          }}
        >
          {buttonText("Delete")}
        </button>
      </Modal.Footer>
    </Modal>
  );
}

export default DoubleComfirmModal;
